import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";

/**
 * Coordinates the loading overlays of the user-overview Advanced Vectoring screen,
 * where the mission-list table (adavance-vectoring-users) and the usage graph
 * (advance-vectoring-users-graph) are separate sibling components. Each reports its
 * own slot; the combined loading$ stays true until BOTH slots are done, so the two
 * overlays appear and disappear in sync.
 *
 * Slot booleans (not a counter) so there is nothing to leak: a component simply sets
 * its own slot false on destroy.
 */
@Injectable({ providedIn: "root" })
export class AdvanceVectoringLoaderService {
  private state: { table: boolean; graph: boolean } = { table: false, graph: false };
  private loadingSubject = new BehaviorSubject<boolean>(false);
  loading$: Observable<boolean> = this.loadingSubject.asObservable();

  set(slot: "table" | "graph", value: boolean): void {
    this.state[slot] = value;
    this.loadingSubject.next(this.state.table || this.state.graph);
  }
}
